import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ChatPayload {
  inputValue: string;
  clientCode: string;
  study: string;
  dataArray: any[];
  landingData: any;
  guidChatId?: string;
  modulesAccess?: any;
}

@Injectable({
  providedIn: 'root'
})
export class SharedChatService {
  private sendMessageRequestSource = new BehaviorSubject<ChatPayload | null>(null);
  sendMessageRequest$ = this.sendMessageRequestSource.asObservable();

  requestSendMessage(payload: ChatPayload) {
    this.sendMessageRequestSource.next(payload);
  }

  clearRequest() {
    this.sendMessageRequestSource.next(null);
  }
}